import {Component, Input} from '@angular/core';
import {
  CalendarViewType,
  Country, EventFilter,
  EventItem,
  EventStatus,
  FindEventsRequest, LengthRange,
  Lookups,
  Sport,
  PublicSearchFilter, isFilterActive
} from "@model";
import {Router} from "@angular/router";
import {MyTraceyTabs} from "../my-tracey.component";
import {
  EVENT_DETAILS,
  PRIVATE_EVENT_CALENDAR_ROUTE,
  PRIVATE_FINISHED_EVENTS_ROUTE
} from "../../../../../app-routing.module";
import {PagingComponent} from "../../../../../components/paging.component";
import {Observable} from "rxjs";
import {UserEventsService} from "@services";

@Component({
  selector: 'app-my-tracey-favorites',
  templateUrl: './my-tracey-favorites.component.html',
  styleUrl: './my-tracey-favorites.component.scss',
  standalone: false
})
export class MyTraceyFavoritesComponent extends PagingComponent<EventItem>{

  @Input({required: true}) languages: Lookups[] = [];

  @Input() countries: Country[] = [];
  @Input() sports: Sport[] = [];
  @Input() favoriteEvents: EventItem[] = [];

  searchFilter: PublicSearchFilter = {};
  lengthRanges: LengthRange[] = EventFilter.LENGTH_RANGES;
  isFilterActive: boolean = false;


  constructor(private router: Router, private userEventsService: UserEventsService) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.showSpinner = false;
    this.handleExploreResult(this.favoriteEvents);
  }


  goToEventDetailsPage(item: EventItem): void {
    if (!item.id) return;
    let isFinished = item.status === EventStatus.FINISHED;
    this.router.navigate(
        [isFinished ? PRIVATE_FINISHED_EVENTS_ROUTE : PRIVATE_EVENT_CALENDAR_ROUTE, EVENT_DETAILS],
        {
          queryParams: {
            eventId: item.id,
            isFinishedEvent: isFinished
          }
        }
    );
  }

  filterChanged(filter: PublicSearchFilter) {
    this.searchFilter = filter;
    this.isFilterActive = isFilterActive(filter);
    this.onExplore();
  }

  private createFilter(): FindEventsRequest {
    return FindEventsRequest.createEventPageFilter(this.page, {...this.searchFilter});
  }

  protected fetchPage(page: number): Observable<EventItem[]> {
    return this.userEventsService.filterUserFavoriteEvents(this.createFilter());
  }

  protected override afterSetItems(items: EventItem[]): void {
    this.favoriteEvents = [...items];
  }

  goToEventCalendar() {
    this.router.navigate([PRIVATE_EVENT_CALENDAR_ROUTE]);
  }

  protected readonly MyTraceyTabs = MyTraceyTabs;
  protected readonly CalendarViewType = CalendarViewType;

}
